const translations = {
  cz: {
    prihlasitse: 'Přihlásit se',
    vasEmail: 'Vaše e-mailová adresa',
    emailLogin: 'E-mail',
    az: 'až',
    od: 'od',
    vlastnosti: 'Vlastnosti',
    inforostliny: 'informace k rostlinám',
    infoobjednavky: 'informace k objednávkám',
    dalsiKontakty: 'další kontakty',
    ucet: 'Uživatelský účet',
    login: 'Můj účet',
    jmenoLogin: 'Uživatelské jméno nebo e-mail',
    hesloLogin: 'Heslo',
    prihlaseniLogin: 'Přihlášení',
    cartDPH: 'Celkem za zboží',
    cartBezDPH: 'Cena bez DPH',
    zpetKNakupovani: 'Zpět k nakupování',
    vasKosik: 'Váš nákupní košík',
    variantTitle: 'Vyberte variantu',
    stockEshop: 'Skladem na e-shopu',
    stockProdejna: 'Skladem na prodejně',
    helperSkladem: 'skladem',
    zobrazitVarianty: 'Zobrazit i vyprodané varianty',
    skrytVarianty: 'Skrýt vyprodané varianty',
    doruceni: 'Možnosti doručení',
    hlidat: 'Hlídat',
    objednavkaOdeslana: 'Děkujeme za Vaši objednávku!',
    recaNumber: 'Vaší objednávce jsme přidělili číslo',
    platbaAdoruceni: 'Informace o platbě a doručení',
    osobniUdaje: 'Vaše osobní údaje a adresa',
    platebniUdaje: 'Platební údaje',
    zakaznickyUcet: 'Máte u nás účet?',
    prihlasteSe: 'Přihlaste se a doručovací údaje se vyplní automaticky.',
    prihlasitSe: 'Přihlásit se',
    continueInOrder: 'Pokračovat v objednávce',
    odeslatObjednavku: 'Odeslat objednávku s povinností platby',
    dalsichFotografii: 'dalších fotografií',
    dalsifotografie: 'další fotografie',
    popisProduktu: 'Popis produktu',
    vlastnosti: 'Vlastnosti',
    produktu: 'Detail produktu',
    raditDle: 'Řadit dle',
    nadpisFiltrace: 'Filtrování produktů',
    nyniUsetrite: 'Nyní ušetříte',
    pridejtejeste: 'Přidejte ještě',
    usetrite: 'a ušetříte',
    ks: 'ks',
    nejlepsicena: 'Máte nejlepší možnou cenu.',
    doporucujemePrikoupit: 'Doporučujeme přikoupit',
    zmenaAdresy: 'Změnit adresu doručení',
    darkovypoukaz: 'Chci uplatnit slevu',
    cartProdukt: 'Produkt',
    cartDostupnost: 'Dostupnost',
    cartPocet: 'Počet',
    cartCenaZaKus: 'Cena za kus',
    cartCelkem: 'Celkem',
    cartsleva: 'Sleva',
    zpetdoobchodu: 'Zpět do obchodu',
    navodnapestovani: 'Návod na pěstování',
    precistClanek: 'Přečíst článek',
    kontakty: 'Kontakty',
    nahratFotku: 'Nahrát vlastní fotku',
  },
 sk: {
    prihlasitse: 'Prihlásiť sa',
    vasEmail: 'Vaša e-mailová adresa',
    emailLogin: 'E-mail',
    az: 'až',
    od: 'od',
    vlastnosti: 'Vlastnosti',
    inforostliny: 'informácie k rastlinám',
    infoobjednavky: 'informácie k objednávkam',
    dalsiKontakty: 'ďalšie kontakty',
    ucet: 'Používateľský účet',
    login: 'Môj účet',
    jmenoLogin: 'Používateľské meno alebo e-mail',
    hesloLogin: 'Heslo',
    prihlaseniLogin: 'Prihlásenie',
    cartDPH: 'Celkom za tovar',
    cartBezDPH: 'Cena bez DPH',
    zpetKNakupovani: 'Späť k nakupovaniu',
    vasKosik: 'Váš nákupný košík',
    variantTitle: 'Vyberte variant',
    stockEshop: 'Skladom na e-shope',
    stockProdejna: 'Skladom na predajni',
    helperSkladem: 'skladom',
    zobrazitVarianty: 'Zobraziť aj vypredané varianty',
    skrytVarianty: 'Skryť vypredané varianty',
    doruceni: 'Možnosti doručenia',
    hlidat: 'Sledovať',
    objednavkaOdeslana: 'Ďakujeme za Vašu objednávku!',
    recaNumber: 'Vašej objednávke sme pridelili číslo',
    platbaAdoruceni: 'Informácie o platbe a doručení',
    osobniUdaje: 'Vaše osobné údaje a adresa',
    platebniUdaje: 'Platobné údaje',
    zakaznickyUcet: 'Máte u nás účet?',
    prihlasteSe: 'Prihláste sa a doručovacie údaje sa vyplnia automaticky.',
    prihlasitSe: 'Prihlásiť sa',
    continueInOrder: 'Pokračovať v objednávke',
    odeslatObjednavku: 'Odoslať objednávku s povinnosťou platby',
    dalsichFotografii: 'ďalších fotografií',
    dalsifotografie: 'ďalšie fotografie',
    popisProduktu: 'Popis produktu',
    produktu: 'Detail produktu',
    raditDle: 'Zoradiť podľa',
    nadpisFiltrace: 'Filtrovanie produktov',
    nyniUsetrite: 'Teraz ušetríte',
    pridejtejeste: 'Pridajte ešte',
    usetrite: 'a ušetríte',
    ks: 'ks',
    nejlepsicena: 'Máte najlepšiu možnú cenu.',
    doporucujemePrikoupit: 'Odporúčame prikúpiť',
    zmenaAdresy: 'Zmeniť adresu doručenia',
    darkovypoukaz: 'Chcem uplatniť zľavu',
    cartProdukt: 'Produkt',
    cartDostupnost: 'Dostupnosť',
    cartPocet: 'Počet',
    cartCenaZaKus: 'Cena za kus',
    cartCelkem: 'Celkom',
    cartsleva: 'Zľava',
    zpetdoobchodu: 'Späť do obchodu',
    kontakty: 'Kontakty',
    navodnapestovani: 'Návod na pestovanie',
    precistClanek: 'Prečítať článok',
    nahratFotku: 'Nahrať vlastnú fotku',
  },

  de: {
    prihlasitse: 'Anmelden',
    vasEmail: 'Ihre E-Mail-Adresse',
    emailLogin: 'E-Mail',
    az: 'bis',
    od: 'von',
    vlastnosti: 'Merkmale',
    inforostliny: 'Informationen zu Pflanzen',
    infoobjednavky: 'Informationen zu Bestellungen',
    dalsiKontakty: 'weitere Kontakte',
    ucet: 'Benutzerkonto',
    login: 'Mein Konto',
    jmenoLogin: 'Benutzername oder E-Mail',
    hesloLogin: 'Passwort',
    prihlaseniLogin: 'Anmeldung',
    cartDPH: 'Gesamtpreis der Waren',
    cartBezDPH: 'Preis ohne MwSt.',
    zpetKNakupovani: 'Zurück zum Einkaufen',
    vasKosik: 'Ihr Warenkorb',
    variantTitle: 'Variante auswählen',
    stockEshop: 'Online auf Lager',
    stockProdejna: 'Im Geschäft auf Lager',
    helperSkladem: 'auf Lager',
    zobrazitVarianty: 'Ausverkaufte Varianten anzeigen',
    skrytVarianty: 'Ausverkaufte Varianten ausblenden',
    doruceni: 'Lieferoptionen',
    hlidat: 'Beobachten',
    objednavkaOdeslana: 'Vielen Dank für Ihre Bestellung!',
    recaNumber: 'Ihre Bestellung hat die Nummer erhalten',
    platbaAdoruceni: 'Informationen zu Zahlung und Lieferung',
    osobniUdaje: 'Ihre persönlichen Daten und Adresse',
    platebniUdaje: 'Zahlungsdaten',
    zakaznickyUcet: 'Haben Sie ein Konto bei uns?',
    prihlasteSe: 'Melden Sie sich an und die Lieferdaten werden automatisch ausgefüllt.',
    prihlasitSe: 'Anmelden',
    continueInOrder: 'Zur Bestellung fortfahren',
    odeslatObjednavku: 'Kostenpflichtig bestellen',
    dalsichFotografii: 'weitere Fotos',
    dalsifotografie: 'weiteres Foto',
    popisProduktu: 'Produktbeschreibung',
    produktu: 'Detail',
    raditDle: 'Sortieren nach',
    nadpisFiltrace: 'Produktfilter',
    nyniUsetrite: 'Jetzt sparen Sie',
    pridejtejeste: 'Fügen Sie noch hinzu',
    usetrite: 'und sparen Sie',
    ks: 'Stk.',
    nejlepsicena: 'Sie haben den bestmöglichen Preis.',
    doporucujemePrikoupit: 'Wir empfehlen zusätzlich',
    zmenaAdresy: 'Lieferadresse ändern',
    darkovypoukaz: 'Rabatt anwenden',
    cartProdukt: 'Produkt',
    cartDostupnost: 'Verfügbarkeit',
    cartPocet: 'Menge',
    cartCenaZaKus: 'Preis pro Stück',
    cartCelkem: 'Gesamt',
    cartsleva: 'Rabatt',
    zpetdoobchodu: 'Zurück zum Shop',
    navodnapestovani: 'Anleitungen zur Pflanzenpflege',
    precistClanek: 'Artikel lesen',
    kontakty: 'Kontakte',
    nahratFotku: 'Foto hochladen',
  },

  pl: {
    prihlasitse: 'Zaloguj się',
    vasEmail: 'Twój adres e-mail',
    emailLogin: 'E-mail',
    az: 'do',
    od: 'od',
    vlastnosti: 'Właściwości',
    inforostliny: 'informacje o roślinach',
    infoobjednavky: 'informacje o zamówieniach',
    dalsiKontakty: 'inne kontakty',
    ucet: 'Konto użytkownika',
    login: 'Moje konto',
    jmenoLogin: 'Nazwa użytkownika lub e-mail',
    hesloLogin: 'Hasło',
    prihlaseniLogin: 'Logowanie',
    cartDPH: 'Razem za produkty',
    cartBezDPH: 'Cena bez VAT',
    zpetKNakupovani: 'Wróć do zakupów',
    vasKosik: 'Twój koszyk',
    variantTitle: 'Wybierz wariant',
    stockEshop: 'Dostępne online',
    stockProdejna: 'Dostępne w sklepie',
    helperSkladem: 'dostępne',
    zobrazitVarianty: 'Pokaż wyprzedane warianty',
    skrytVarianty: 'Ukryj wyprzedane warianty',
    doruceni: 'Opcje dostawy',
    hlidat: 'Obserwuj',
    objednavkaOdeslana: 'Dziękujemy za Twoje zamówienie!',
    recaNumber: 'Twojemu zamówieniu nadano numer',
    platbaAdoruceni: 'Informacje o płatności i dostawie',
    osobniUdaje: 'Twoje dane osobowe i adres',
    platebniUdaje: 'Dane płatności',
    zakaznickyUcet: 'Masz u nas konto?',
    prihlasteSe: 'Zaloguj się, a dane dostawy wypełnią się automatycznie.',
    prihlasitSe: 'Zaloguj się',
    continueInOrder: 'Kontynuuj zamówienie',
    odeslatObjednavku: 'Złóż zamówienie z obowiązkiem zapłaty',
    dalsichFotografii: 'więcej zdjęć',
    dalsifotografie: 'dodatkowe zdjęcie',
    popisProduktu: 'Opis produktu',
    produktu: 'Szczegóły produktu',
    raditDle: 'Sortuj według',
    nadpisFiltrace: 'Filtrowanie produktów',
    nyniUsetrite: 'Teraz oszczędzasz',
    pridejtejeste: 'Dodaj jeszcze',
    usetrite: 'i oszczędź',
    ks: 'szt.',
    nejlepsicena: 'Masz najlepszą możliwą cenę.',
    doporucujemePrikoupit: 'Polecamy dokupić',
    zmenaAdresy: 'Zmień adres dostawy',
    darkovypoukaz: 'Chcę użyć rabatu',
    cartProdukt: 'Produkt',
    cartDostupnost: 'Dostępność',
    cartPocet: 'Ilość',
    cartCenaZaKus: 'Cena za sztukę',
    cartCelkem: 'Razem',
    cartsleva: 'Rabat',
    zpetdoobchodu: 'Wróć do sklepu',
    kontakty: 'Kontakt',
    precistClanek: 'Przeczytaj artykuł',
    navodaNaPestovani: 'Instrukcje uprawy roślin',
    nahratFotku: 'Prześlij zdjęcie',
  },

  hu: {
    prihlasitse: 'Bejelentkezés',
    vasEmail: 'Az Ön e-mail címe',
    emailLogin: 'E-mail',
    az: '-ig',
    od: '-tól',
    vlastnosti: 'Jellemzők',
    inforostliny: 'információk a növényekről',
    infoobjednavky: 'információk a rendelésekről',
    dalsiKontakty: 'további kapcsolatok',
    ucet: 'Felhasználói fiók',
    login: 'Fiókom',
    jmenoLogin: 'Felhasználónév vagy e-mail',
    hesloLogin: 'Jelszó',
    prihlaseniLogin: 'Bejelentkezés',
    cartDPH: 'Összesen a termékekért',
    cartBezDPH: 'Ár ÁFA nélkül',
    zpetKNakupovani: 'Vissza a vásárláshoz',
    vasKosik: 'Kosár',
    variantTitle: 'Válasszon változatot',
    stockEshop: 'Raktáron az e-shopban',
    stockProdejna: 'Raktáron az üzletben',
    helperSkladem: 'raktáron',
    zobrazitVarianty: 'Elfogyott változatok megjelenítése',
    skrytVarianty: 'Elfogyott változatok elrejtése',
    doruceni: 'Szállítás',
    hlidat: 'Figyelés',
    objednavkaOdeslana: 'Köszönjük rendelését!',
    recaNumber: 'Rendelésének száma',
    platbaAdoruceni: 'Fizetési és szállítási információk',
    osobniUdaje: 'Személyes adatok és cím',
    platebniUdaje: 'Fizetési adatok',
    zakaznickyUcet: 'Van nálunk fiókja?',
    prihlasteSe: 'Jelentkezzen be, és a szállítási adatok automatikusan kitöltődnek.',
    prihlasitSe: 'Bejelentkezés',
    continueInOrder: 'Tovább a rendeléshez',
    odeslatObjednavku: 'Megrendelés fizetési kötelezettséggel',
    dalsichFotografii: 'további fénykép',
    dalsifotografie: 'további fénykép',
    popisProduktu: 'Termékleírás',
    produktu: 'Termék részletei',
    raditDle: 'Rendezés',
    nadpisFiltrace: 'Termékszűrés',
    nyniUsetrite: 'Most megtakarít',
    pridejtejeste: 'Adjon hozzá még',
    usetrite: 'és megtakarít',
    ks: 'db',
    nejlepsicena: 'Öné a legjobb ár.',
    doporucujemePrikoupit: 'Ajánljuk még',
    zmenaAdresy: 'Szállítási cím módosítása',
    darkovypoukaz: 'Szeretnék kedvezményt érvényesíteni',
    cartProdukt: 'Termék',
    cartDostupnost: 'Elérhetőség',
    cartPocet: 'Mennyiség',
    cartCenaZaKus: 'Egységár',
    cartCelkem: 'Összesen',
    cartsleva: 'Kedvezmény',
    zpetdoobchodu: 'Vissza az áruházba',
    kontakty: 'Kapcsolatok',
    navodnapestovani: 'Növénytermesztési útmutató',
    precistClanek: 'Cikk elolvasása',
    navodaNaPestovani: 'Instrukcje uprawy roślin',
    nahratFotku: 'Fotó feltöltése',
  }
};

function translation(key) {
  const lang = $('html').attr('lang') || 'cz';
  const parts = key.split('.');
  const requestedLang = parts.length > 1 ? parts[0] : lang;
  const realKey = parts.length > 1 ? parts[1] : parts[0];
  return translations[requestedLang] && translations[requestedLang][realKey]
    ? translations[requestedLang][realKey]
    : translations['cz'][realKey] || key;
}